import React from "react";
import PropTypes from "prop-types";

class FeatureFlagInitializationBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {failed: false};
  }

  static getDerivedStateFromError() {
    return {failed: true};
  }

  componentDidCatch(error) {
    console.error("Feature flags failed to initialize; continuing with defaults", error);
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

FeatureFlagInitializationBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node.isRequired,
};

export default FeatureFlagInitializationBoundary;
